<template>
  <div class="tag-list">
    <Tabs
      v-if="tagList.length > 0"
      v-model="curTag"
      type="card"
      :closable="tagList.length > 1"
      :before-remove="removeTagBefore"
      @on-tab-remove="removeTag"
      @on-click="tabsChange"
    >
      <TabPane
        :label="item.title"
        :name="item.fullPath"
        v-for="(item) in tagList"
        :key="item.fullPath"
      ></TabPane>
    </Tabs>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      tagList: [],
      curTag:"",
      delTagPath:"",
    };
  },
  watch: {
    tagList:{
      handler(newValue) {
        let pageTabTagPaths = newValue.map(item=>item.fullPath);
        window.localStorage.setItem('pageTabTagPaths', JSON.stringify(pageTabTagPaths));
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    window.addEventListener("message", (e) => {
      if (!e.data||!e.data.appMessage) {
        return;
      }
      if (e.data.webChange) {
        if(e.data.webChange.path=="/empty"){
          return;
        }
        this.addTag(e.data.webChange)
        return;
      }
      if(e.data.removePageTag){
        this.delTagPath = this.curTag;
        this.removeTag(e.data.removePageTag)
      }
      if(e.data.setTagName){
        const data = this.tagList.find(item=>item.fullPath==this.curTag);
        data.title = e.data.setTagName;
      }
    })
  },
  methods: {
    // 新增标签
    addTag(data){
      this.curTag = data.fullPath
      if (this.checkTapDuplication(data) > -1) {

      } else {
        this.tagList.push(data);
        if (this.tagList.length > 8) {
          this.tagList.shift();
        }
      }
    },
    // 校验去重
    checkTapDuplication(data) {
      let index = this.tagList.findIndex(item=>{
        return item.fullPath == data.fullPath
      })
      return index;
    },
    // 删除标签
    removeTag(fullPath){
      const index = this.tagList.findIndex(item=>{
        return item.fullPath == fullPath
      })
      this.$emit("clearWebTags",this.tagList[index]);
      this.tagList.splice(index, 1);
      if(this.delTagPath == fullPath){
        this.$emit("openPage",this.tagList[Math.max(index-1,0)].fullPath);
      }
    },
    // 删除标签之前
    removeTagBefore(){
      this.delTagPath = this.curTag;
      return Promise.resolve();
    },
    // 切换
    tabsChange(){
      let parentUrl = this.tagList.find(i => i.fullPath == this.curTag).parentUrl;
      if(parentUrl){
        this.$emit("refreshLeftMenu",parentUrl);
      }
      this.$emit("openPage",this.curTag);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./tagList.scss";
</style>